var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikefilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 7.875C19.25 7.41087 19.0656 6.96575 18.7374 6.63756C18.4092 6.30937 17.9641 6.125 17.5 6.125H11.97L12.81 2.12625C12.8275 2.03875 12.8363 1.9425 12.8363 1.84625C12.8363 1.4875 12.6875 1.155 12.4513 0.91875L11.5238 0L5.76625 5.7575C5.4425 6.08125 5.25 6.51875 5.25 7V15.75C5.25 16.2141 5.43437 16.6592 5.76256 16.9874C6.09075 17.3156 6.53587 17.5 7 17.5H14.875C15.6012 17.5 16.2225 17.0625 16.485 16.4325L19.1275 10.2638C19.2063 10.0625 19.25 9.8525 19.25 9.625V7.875ZM0 17.5H3.5V7H0V17.5Z",
    fill: "#6D44E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikefilled);
export default __webpack_public_path__ + "static/media/likefilled.2adc3cc4e1aa0aaf80e4d8fc8e031ce4.svg";
export { ForwardRef as ReactComponent };